import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import {
  AggregateMetricsRequest,
  NumericAggregateMetricsResponse,
} from "../MetricRecord";

/**
 * Aggregate a metric across sessions, grouped by calendar period. Backs the
 * top-level / device dashboard's chart cards.
 */
export function useAggregateMetrics(
  request: AggregateMetricsRequest | undefined,
  orgId: string | undefined,
) {
  const { metricsService } = useDomainServices();

  return useQuery<NumericAggregateMetricsResponse, Error>({
    queryKey: ["metricsAggregate", request, orgId],
    queryFn: ({ signal }) => {
      if (request === undefined) {
        return Promise.reject(new Error("Missing aggregate request"));
      }
      return metricsService.aggregateMetric(request, {
        abortSignal: signal,
        orgId,
      });
    },
    enabled: request !== undefined && orgId !== undefined,
    staleTime: 60_000,
  });
}
